// extracted by mini-css-extract-plugin
export var icon = "_5q-1";
export var subtext = "_5q-0";